/*
  IL | Add-on card. NOT part of Prestige. Markup: snippets/il-addon.liquid and il-addon-item.liquid.

  Cosmetic only. The checked radio already IS the variant the form posts, so the add works with
  this file missing. All it does is keep the photo, the price in the button and the colour name in
  step with the swatch the customer picked.

  The change event is stopped here, at the card, so it never reaches Prestige's product page
  listeners further up. Those treat any change inside the product info column as the MAIN
  product's variant changing, and the add-on's colours are nothing to do with that.
*/
if (!customElements.get('il-addon')) {
  customElements.define('il-addon', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || !input.hasAttribute('data-il-addon-price')) return;
        event.stopPropagation();

        const item = input.closest('.il-addon__item');
        if (!item) return;

        const price = item.querySelector('span[data-il-addon-price]');
        if (price) price.textContent = input.dataset.ilAddonPrice;

        const name = item.querySelector('[data-il-addon-name]');
        if (name) name.textContent = input.dataset.ilAddonLabel;

        const img = item.querySelector('.il-addon__img');
        if (img && input.dataset.ilAddonImg) {
          img.removeAttribute('srcset');
          img.src = input.dataset.ilAddonImg;
        }
      });
    }
  });
}
